import { Box } from "@mui/material"
import { useState } from "react"
import LocationSelector from "../../screens/Maps/LocationSelector"
import ActionableInputField from "../InputFields/ActionableInputField"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { showError, showSuccess } from "../../utils/snackbar"

const findLatLongIndexes = (fields = []) => {
    let latIndex = null
    let longIndex = null

    fields.forEach((field, index) => {
        if (field.details?.type === "latitude" && latIndex === null) {
            latIndex = index
        }
        if (field.details?.type === "longitude" && longIndex === null) {
            longIndex = index
        }
    })

    return { latIndex, longIndex }
}

const LocationPickerField = ({
    controllerField,
    fieldState,
    getValues,
    setValue,
    voiceiiTags,
    label,
    required,
    isLatitude,
    isLongitude,
}) => {
    const [mapPicker, setMapPicker] = useState({
        open: false,
        latIndex: null,
        longIndex: null,
    })

    const { latIndex, longIndex } = findLatLongIndexes(getValues("assetProperty"))

    const lat = latIndex !== null ? getValues(`assetProperty.${latIndex}.assetValue`) : ""
    const lng = longIndex !== null ? getValues(`assetProperty.${longIndex}.assetValue`) : ""

    const openMapPicker = () => {
        setMapPicker({ open: true, latIndex, longIndex })
    }

    const handleClear = () => {
        controllerField.onChange("")
    }

    const handleMapSelect = ({ lat, lng }) => {
        if (latIndex !== null) {
            setValue(`assetProperty.${latIndex}.assetValue`, lat, { shouldDirty: true })
        }
        if (longIndex !== null) {
            setValue(`assetProperty.${longIndex}.assetValue`, lng, { shouldDirty: true })
        }
    }
    const copyCoordinates = async () => {
        if (navigator?.clipboard) {
            await navigator.clipboard.writeText(`${lat}, ${lng}`)
            showSuccess(
                voiceiiTags("Coordinates copied to clipboard") || voiceiiTags("Success"),
            )
        } else {
            showError(
                voiceiiTags("Copy not supported in this browser") || voiceiiTags("Error"),
            )
        }
    }

    const openInMaps = () => {
        const url = `https://www.google.com/maps?q=${lat},${lng}`
        window.open(url, "_blank")
    }

    return (
        <Box sx={{ width: "100%" }}>
            {/* INPUT WITH FLOATING ICON BUTTONS */}
            <ActionableInputField
                value={controllerField.value}
                onChange={(e) => controllerField.onChange(e.target.value)}
                onClear={handleClear}
                onMenuClick={openMapPicker}
                showClear={false}
                showMenu={false}
                textFieldProps={{
                    type: "number",
                    placeholder: voiceiiTags("Enter or pick from map"),
                    label,
                    required,
                    error: !!fieldState.error,
                    helperText: fieldState.error?.message,
                }}
            />
            {isLatitude && (
                <Box className="e-location-actions">
                    <Box onClick={() => copyCoordinates()} className="e-location-action-btn">
                        <ContentCopyIcon className="fs-6" /> {voiceiiTags("Copy")}
                    </Box>
                </Box>
            )}
            {isLongitude && (
                <Box className="e-location-actions">
                    <Box onClick={() => openInMaps()} className="e-location-action-btn">
                        <OpenInNewIcon className="fs-6" /> {voiceiiTags("Open in Maps")}
                    </Box>
                </Box>
            )}
        </Box>
    )
}

/**
 * Standalone map component rendered separately from the lat/long input fields.
 * Should be placed in a full-width container below both lat/long fields.
 */
const LocationMapDisplay = ({ getValues, setValue, voiceiiTags }) => {
    const { latIndex, longIndex } = findLatLongIndexes(getValues("assetProperty"))

    const lat = latIndex !== null ? getValues(`assetProperty.${latIndex}.assetValue`) : ""
    const lng = longIndex !== null ? getValues(`assetProperty.${longIndex}.assetValue`) : ""

    const handleMapSelect = ({ lat, lng }) => {
        if (latIndex !== null) {
            setValue(`assetProperty.${latIndex}.assetValue`, lat, { shouldDirty: true })
        }
        if (longIndex !== null) {
            setValue(`assetProperty.${longIndex}.assetValue`, lng, { shouldDirty: true })
        }
    }

    return (
        <Box className="e-location-map-wrapper">
            <LocationSelector
                height="200px"
                value={
                    lat && lng
                        ? {
                              lat: Number(lat),
                              lng: Number(lng),
                          }
                        : null
                }
                onChange={handleMapSelect}
                showInputs={false}
            />
        </Box>
    )
}

export { LocationMapDisplay }
export default LocationPickerField
